import { render, staticRenderFns } from "./AipZoneConfiguration.vue?vue&type=template&id=051dfa6c&scoped=true&"
import script from "./AipZoneConfiguration.vue?vue&type=script&lang=js&"
export * from "./AipZoneConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./AipZoneConfiguration.vue?vue&type=style&index=0&id=051dfa6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051dfa6c",
  null
  
)

export default component.exports